import { isEmpty } from 'lodash-es';
import React from 'react';

import {
  EAllowStatus,
  ITargetingPreset,
  TargetingPresetKey,
} from '~/src/dash/apiV2/targeting/targetingPresets';
import { IDaypartingParsed } from '~/src/dash/components/forms/formBuilder/ParameterRow/editors/DaypartingBuilder/common';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { fontSizing, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IDaypartingSchedule {
  Monday: [string, string][];
  Tuesday: [string, string][];
  Wednesday: [string, string][];
  Thursday: [string, string][];
  Friday: [string, string][];
  Saturday: [string, string][];
  Sunday: [string, string][];
}

const days: (keyof IDaypartingSchedule)[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const formatSchedule = (schedule: IDaypartingSchedule) => {
  if (isEmpty(schedule)) return [];
  const result: string[] = [];
  days.forEach((day) => {
    const slots = schedule[day];
    if (slots && !isEmpty(slots)) {
      slots.forEach((slot) => {
        result.push(`${day}: [${slot[0]} - ${slot[1]}]`);
      });
    }
  });
  return result;
};

export interface IDaypartingSummaryProps {
  preset: ITargetingPreset;
  valueKey: TargetingPresetKey;
  allowKey: TargetingPresetKey;
}

export const DaypartingSummary = ({ preset, valueKey, allowKey }: IDaypartingSummaryProps) => {
  // @ts-ignore
  const dayparting: IDaypartingParsed = !!preset[valueKey] ? JSON.parse(preset[valueKey]) : {};
  const isEnabled = dayparting && !isEmpty(dayparting) && dayparting.Enabled;

  let timezoneType = '';
  let schedule: string[] = [];

  if (isEnabled) {
    timezoneType = dayparting.EnableViewerTimezone ? 'Viewer' : 'Bidder';
    schedule = formatSchedule(dayparting.Schedule as IDaypartingSchedule);
  }

  return (
    <div>
      {isEnabled && allowKey && (
        <Text small>
          Logic:
          <span
            style={{
              verticalAlign: 'middle',
              lineHeight: fontSizing.small,
              paddingLeft: spacing.extraSmall,
              paddingRight: spacing.extraSmall,
            }}
          >
            {preset[allowKey] !== EAllowStatus.DENY ? (
              <IconV2 name='available' color={publicaColors.green} />
            ) : (
              <IconV2 name='unavailable' color={publicaColors.red} />
            )}
          </span>
        </Text>
      )}
      {timezoneType && <Text small>{`Timezone: ${timezoneType}`}</Text>}
      {schedule.map((daySchedule) => {
        return <Text small>{daySchedule}</Text>;
      })}
    </div>
  );
};
